<template>
  <admin-wrapper
    title-translation-path="admin.dataGeneral"
    subtitle-path="admin.dataPublicSubtitle"
    :hasButtons="false"
  >
    <template #form>
      <admin-tabs-layers scope="core" schema_scope="core" :tab-prop="tab"></admin-tabs-layers>
    </template>
  </admin-wrapper>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import AdminTabsLayers from '@/components/AdminTabsLayers';

export default {
  name: 'AdminDataPublic',
  props: {
    tab: {
      type: Number,
      default: 0,
    },
  },
  components: {
    AdminWrapper,
    AdminTabsLayers,
  },
};
</script>
